import { smText } from '../../../../style/text'
import { AnimatePresence, motion } from 'framer-motion'
import { ChevronRightIcon } from '@heroicons/react/24/solid'

const Breadcrumbs = ({ utils }: any) => {
    const {
        openedFolder,
        setSelectedFolderIndex
    } = utils

    return (
        <div className='flex items-center gap-1'>
            <motion.p
                className={`${smText} font-medium cursor-pointer`}
                animate={openedFolder ? { opacity: .5 } : { opacity: 1 }}
                transition={{
                    ease: 'easeInOut',
                }}
                onClick={() => setSelectedFolderIndex(undefined)}
            >
                Website
            </motion.p>
            <AnimatePresence>
                {openedFolder && (
                    <motion.div
                        className='overflow-hidden'
                        initial={{ width: 0 }}
                        animate={{
                            width: "100%",
                            transition: { duration: 0.4, ease: "easeInOut" },
                        }}
                        exit={{
                            width: 0,
                            transition: { duration: 0.3, ease: "easeInOut" },
                        }}
                        // transition={{
                        //     duration: 0.4,
                        //     ease: "easeInOut"
                        // }}
                    >
                        <div className='flex gap-1 min-w-[500px]'>
                            <ChevronRightIcon width={20} />
                            <p
                                className={`${smText} font-medium whitespace-nowrap`}
                            >
                                {openedFolder.name}
                            </p>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default Breadcrumbs